import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { 
  TrendingUp, AlertTriangle, Globe, Target, Shield, CheckCircle2
} from 'lucide-react';

const insights = [
  {
    icon: Target,
    title: 'Highest Value',
    content: 'United States holds the highest brand value in CONCACAF ($240M–$340M range), representing approximately 1.4x Mexico\'s valuation and 4.5x Canada\'s current position.',
    highlight: 'USA',
  },
  {
    icon: TrendingUp,
    title: 'Fastest Growth',
    content: 'Canada demonstrates the highest growth velocity at +34.2% YoY, driven by improved FIFA ranking and Davies-led roster brand development. Current trajectory suggests potential challenger status by 2027.',
    highlight: 'CAN',
  },
  {
    icon: AlertTriangle,
    title: 'Leadership Risk Assessment',
    content: 'Mexico maintains consistent brand presence but shows decelerating growth (+8.2% YoY). Gap to USA widening. Risk of Canada overtaking Mexico for #2 position within 3-year horizon: 35% probability.',
    highlight: 'Risk',
  },
  {
    icon: Globe,
    title: '2026 World Cup Host Advantage',
    content: 'Co-hosting provides structural tailwind for all three CONCACAF nations. USA positioned to capture disproportionate share (est. 60% of regional host premium) due to venue count and commercial infrastructure.',
    highlight: 'USA',
  },
  {
    icon: CheckCircle2,
    title: 'Strategic Recommendation',
    content: 'Maintain brand leadership through accelerated digital engagement and sponsor portfolio expansion. Monitor Canada\'s growth trajectory. Defensive positioning against Mexico not required given current gap stability.',
    highlight: 'Action',
  },
];

// Insight Card Component
const InsightCard = ({ insight, index, isLast }) => (
  <Card 
    className={`bg-card border-border/50 hover:border-border transition-colors ${
      isLast ? 'md:col-span-2 lg:col-span-1' : ''
    }`}
    data-testid={`insight-card-${index}`}
  >
    <CardHeader className="pb-3">
      <div className="flex items-center gap-3">
        <div className="p-2 rounded-lg bg-muted/50">
          <insight.icon className="w-5 h-5 text-muted-foreground" />
        </div>
        <CardTitle className="text-sm font-semibold">{insight.title}</CardTitle>
      </div>
    </CardHeader>
    <CardContent>
      <p className="text-sm text-muted-foreground leading-relaxed">
        {insight.content}
      </p>
      <div className="mt-3 pt-3 border-t border-border/50">
        <Badge variant="outline" className="text-xs">
          {insight.highlight}
        </Badge>
      </div>
    </CardContent>
  </Card>
);

// SECTION 3: Strategic Intelligence Summary
export const StrategicSummary = () => {
  return (
    <section className="mb-10" data-testid="strategic-intelligence-section">
      <div className="flex items-center gap-3 mb-6">
        <Shield className="w-6 h-6 text-primary" />
        <h2 className="text-lg font-semibold text-foreground tracking-tight">Strategic Intelligence Summary</h2>
      </div>
      
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {insights.map((insight, i) => (
          <InsightCard 
            key={i} 
            insight={insight} 
            index={i} 
            isLast={i === insights.length - 1} 
          />
        ))}
      </div>
    </section>
  );
};

export default StrategicSummary;
